import { Input } from 'legacy/lut/library/inputs'
import React, { ForwardedRef } from 'react'

import { IInputProps } from 'core-components/library/inputs/'
import { IValidatorProps, ValidateInputWrapper } from 'core-components/library/validation'
import { IValidatorClassesProps } from 'core-components/library/validation/models/IValidatorClassesProps'

interface IValidateInput
  extends Omit<IInputProps, 'classes'>,
    Omit<IValidatorProps, 'classes'>,
    IValidatorClassesProps {
  translation?: string
  value: string
}

export const ValidateInput = React.forwardRef(
  (props: IValidateInput, ref: ForwardedRef<HTMLInputElement>) => {
    return <ValidateInputWrapper {...props} InputComponent={Input} inputRef={ref} />
  }
)
